import React from 'react';
import Profile from '../Profile/ProfileLarge';
import ContactMe from '../ContactMe';

export default class MyStory extends React.Component {
	constructor(props) {
		super(props);
	}
	
	render(){
		return(
			<div>
				<Profile resources={this.props.resources} />
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyStory/MyStoryContainer.js